<template>
  <div class="dowmload-content">
    <div class="download-block">
      <div class="left-downloadText">
        <h3 class="intro-title">随时随地签合同</h3>
        <p class="intro-text">国内专业的电子合同、电子签名服务，有超过1.9亿用户正在使用e签宝</p>
        <div class="download-btns">
          <div class="ios-downloadBtn downloadBtn" @click="gotoIosStore">
            <img :src="require('@/assets/images/ios-icon.svg')" alt="" class="ios-icon" />
            <span class="downloadBtn-text">iOS下载</span>
            <img class="ios-Qrcode" src="http://asset.esign.cn/common/img/ios-esign-download.png" />
          </div>
          <div class="android-downloadBtn downloadBtn" @click="gotoAndroidStore">
            <img :src="require('@/assets/images/android-icon.svg')" alt="" class="android-icon" />
            <span class="downloadBtn-text">Android下载</span>
            <img
              class="android-Qrcode"
              src="https://cdn.tsign.cn/newbattle/prod/image/20190829165331670343d47cac3a44c84be59d3dfbb468fb52de.png"
              alt
            />
          </div>
        </div>
      </div>
      <div class="right-bigImg">
        <img src="@/assets/images/bankeys-downloadBg.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { isClient } from '@/lib/utils'

export default {
  data() {
    return {
      isPhone: isClient(),
    }
  },
  methods: {
    gotoIosStore() {
      if (!this.isPhone) {
        return
      }
      window.location.href = 'https://itunes.apple.com/app/id997614073'
    },
    gotoAndroidStore() {
      if (!this.isPhone) {
        return
      }
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.tsign.esign&fromcase=40002'
    },
  },
}
</script>

<style lang="less" scoped>
.dowmload-content {
  width: 100%;
  min-height: calc(100% - 34px);
  background: #fff url('../../assets/images/bankeysPC-downloadBg.png') right top no-repeat;
  background-size: 530px 100%;
  .download-block {
    width: 77.8%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left-downloadText {
      margin-top: 188px;
      .intro-title {
        font-size: 40px;
        font-weight: 500;
        color: #1a1a1a;
        line-height: 56px;
        height: 56px;
        margin-bottom: 8px;
      }
      .intro-text {
        height: 28px;
        font-size: 18px;
        font-weight: 400;
        color: #666;
        line-height: 28px;
      }
      .download-btns {
        margin: 40px 0 24px;
        .downloadBtn {
          width: 168px;
          height: 52px;
          line-height: 52px;
          border-radius: 26px;
          font-size: 18px;
          color: #fff;
          display: inline-block;
          text-align: center;
          cursor: pointer;
          background: linear-gradient(225deg, rgba(255, 72, 92, 1) 0%, rgba(255, 115, 95, 1) 100%);
          box-shadow: 0px 2px 6px 0px rgba(145, 1, 1, 0.2);
          position: relative;
          &:hover,
          &:active {
            background: linear-gradient(225deg, rgba(255, 109, 125, 1) 0%, rgba(255, 156, 142, 1) 100%);
            box-shadow: 0px 2px 6px 0px rgba(145, 1, 1, 0.2);
          }
          .ios-icon {
            width: 20px;
            height: auto;
            display: inline-block;
            vertical-align: middle;
          }
          .android-icon {
            width: 18px;
            height: auto;
            display: inline-block;
            vertical-align: middle;
          }
          .downloadBtn-text {
            display: inline-block;
            vertical-align: middle;
            margin-left: 4px;
          }
        }
        .ios-downloadBtn {
          margin-right: 40px;
          .ios-Qrcode {
            width: 136px;
            height: 136px;
            border: 1px solid #e4e4e4;
            position: absolute;
            top: 78px;
            left: 16px;
            display: none;
          }
          &:hover {
            .ios-Qrcode {
              display: block;
            }
          }
        }
        .android-downloadBtn {
          .android-Qrcode {
            width: 136px;
            height: 136px;
            border: 1px solid #e4e4e4;
            position: absolute;
            top: 78px;
            left: 16px;
            display: none;
          }
          &:hover {
            .android-Qrcode {
              display: block;
            }
          }
        }
      }
    }
    .right-bigImg {
      width: 35.7%;
      height: auto;
      margin: 70px 0 200px;
    }
  }
}
@media (max-width: 768px) {
  .dowmload-content {
    background: none;
    min-height: calc(100% - 41px);
    .download-block {
      display: block;
      width: 100%;
      margin: 0;
      background: #fff;
      .left-downloadText {
        width: 100%;
        height: 280px;
        margin-top: 0;
        padding-top: 36px;
        text-align: center;
        background: url('../../assets/images/bankeysH5-goodsBg.png') left top no-repeat;
        .intro-title {
          font-size: 24px;
          font-weight: 500;
          color: #fff;
          line-height: 24px;
          height: 24px;
        }
        .intro-text {
          width: 311px;
          margin: 12px auto 32px;
          font-size: 16px;
          font-weight: 400;
          color: #fff;
          line-height: 24px;
          height: auto;
        }
        .download-btns {
          margin: 0 0 40px 0;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          .downloadBtn {
            width: 151px;
            &:hover {
              background: linear-gradient(225deg, rgba(255, 72, 92, 1) 0%, rgba(255, 115, 95, 1) 100%);
              box-shadow: 0px 2px 6px 0px rgba(145, 1, 1, 0.2);
            }
          }
          .ios-downloadBtn {
            margin-right: 0;
            &:hover {
              .ios-Qrcode {
                display: none;
              }
            }
          }
          .android-downloadBtn {
            &:hover {
              .android-Qrcode {
                display: none;
              }
            }
          }
        }
      }
      .right-bigImg {
        width: 310px;
        margin: -36px auto 0;
      }
    }
  }
}
</style>
